export default __webpack_public_path__ + "static/media/Beental-Jaipur-Banner_1.97d5d8f6.jpg";